/**
 * Типи для сервісів та stores в Kernel
 * Забезпечує типобезпеку при роботі з контейнером залежностей
 */

/**
 * Базовий інтерфейс для сервісу
 */
export interface IKernelService {
    readonly name: string
}

/**
 * Базовий інтерфейс для store
 */
export interface IKernelStore {
    readonly name: string
}

/**
 * Типізована мапа сервісів
 */
export type ServiceMap = Map<string, IKernelService | unknown>

/**
 * Типізована мапа stores
 */
export type StoreMap = Map<string, IKernelStore | unknown>

/**
 * Типи помилок ядра
 */
export class KernelError extends Error {
    constructor(
        message: string,
        public readonly code: string,
        public readonly context?: Record<string, unknown>
    ) {
        super(message)
        this.name = 'KernelError'
    }
}

export class LoaderError extends KernelError {
    constructor(
        message: string,
        public readonly loaderName: string,
        context?: Record<string, unknown>
    ) {
        super(message, 'LOADER_ERROR', { ...context, loaderName })
        this.name = 'LoaderError'
    }
}

export class ServiceNotFoundError extends KernelError {
    constructor(serviceName: string) {
        super(`Service "${serviceName}" not found in kernel`, 'SERVICE_NOT_FOUND', { serviceName })
        this.name = 'ServiceNotFoundError'
    }
}

export class StoreNotFoundError extends KernelError {
    constructor(storeName: string) {
        super(`Store "${storeName}" not found in kernel`, 'STORE_NOT_FOUND', { storeName })
        this.name = 'StoreNotFoundError'
    }
}
